/**
 * Quantity-multiple helpers + toast UI for products with
 * metafield custom.quantity_multiple.
 */
(function () {
  if (window.KLQuantityMultiple) return;

  const ICONS = {
    error:
      '<svg width="7" height="8" viewBox="0 0 7 8" fill="none" aria-hidden="true"><rect x="5.9751" y="0.818024" width="1" height="8" transform="rotate(45 5.9751 0.818024)" fill="white"/><rect x="6.68213" y="6.47488" width="1" height="8" transform="rotate(135 6.68213 6.47488)" fill="white"/></svg>',
    success:
      '<svg fill="none" height="7" viewBox="0 0 7 7" width="7" aria-hidden="true"><path d="m3.46762 5.27917-2.754073-2.72918-.71355643.70711 2.75406943 2.72918z" fill="#fff"/><path d="m0 0h6.02588v1.00457h-6.02588z" transform="matrix(-.71031 .703889 .71031 .703889 6.32977 1.03186)" fill="#fff"/></svg>'
  };

  function getLocales() {
    return (window.KROWN && KROWN.settings && KROWN.settings.locales) || {};
  }

  function getStack() {
    let stack = document.querySelector('.kl-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'kl-toast-stack';
      stack.setAttribute('aria-live', 'polite');
      document.body.appendChild(stack);
    }
    return stack;
  }

  function showToast({ type = 'error', title = '', message = '', timeout = 8000 } = {}) {
    const stack = getStack();
    const toast = document.createElement('div');
    toast.className = `kl-toast kl-toast--${type}`;
    toast.setAttribute('role', type === 'error' ? 'alert' : 'status');

    toast.innerHTML = `
      <div class="kl-toast__header">
        <span class="kl-toast__icon">${ICONS[type] || ICONS.error}</span>
        <p class="kl-toast__title"></p>
        <button type="button" class="kl-toast__close" aria-label="Close">×</button>
      </div>
      <div class="kl-toast__body"></div>
    `;

    toast.querySelector('.kl-toast__title').textContent = title;
    toast.querySelector('.kl-toast__body').innerHTML = message;

    const close = () => {
      toast.remove();
      if (!stack.children.length) stack.remove();
    };

    toast.querySelector('.kl-toast__close').addEventListener('click', close);
    stack.appendChild(toast);

    if (timeout > 0) {
      setTimeout(() => {
        if (toast.isConnected) close();
      }, timeout);
    }

    return toast;
  }

  function parseMultiple(value) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) && n > 1 ? n : 0;
  }

  function readMultipleFrom(el) {
    if (!el) return 0;
    return (
      parseMultiple(el.dataset.qtyMultiple) ||
      parseMultiple(el.getAttribute('data-qty-multiple')) ||
      0
    );
  }

  function isValidQuantity(quantity, multiple) {
    const qty = parseInt(quantity, 10);
    const mult = parseMultiple(multiple);
    if (!mult) return true;
    if (!Number.isFinite(qty) || qty < 1) return false;
    return qty % mult === 0;
  }

  function productLabel(el) {
    if (!el) return '';
    return (el.dataset.productTitle || el.dataset.productSku || '').trim();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function showInvalidToast(el, multiple) {
    const locales = getLocales();
    const mult = parseMultiple(multiple);
    const label = productLabel(el);
    const title =
      locales.products_quantity_multiple_error_title || 'Unable to add product to cart';
    let message;
    if (label) {
      message = (locales.products_quantity_multiple_error || '')
        .replace('__SKU__', `<strong>${escapeHtml(label)}</strong>`)
        .replace('__QTY__', String(mult));
    } else {
      message = (locales.products_quantity_multiple_error_generic || '')
        .replace('__QTY__', String(mult));
    }
    showToast({ type: 'error', title, message });
  }

  function showSuccessToast() {
    const locales = getLocales();
    const cartUrl =
      (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_url) ||
      '/cart';
    const title =
      locales.products_quantity_multiple_success_title || 'Your item has been added to cart';
    const message =
      locales.products_quantity_multiple_success ||
      `The selected item(s) have been successfully added to your shopping cart. You can continue shopping or <a href="${cartUrl}">view your cart.</a>`;
    showToast({ type: 'success', title, message });
  }

  function getFormQuantity(formRoot) {
    const qtyInput = formRoot.querySelector('[name="quantity"]');
    return qtyInput ? parseInt(qtyInput.value, 10) : 1;
  }

  function ensureCheckoutGuard(paymentButton) {
    let guard = paymentButton.querySelector('.kl-qty-multiple-checkout-guard');
    if (guard) return guard;

    paymentButton.classList.add('kl-qty-multiple-checkout-host');
    // Use a div (not button) so global theme button styles can't paint it black.
    guard = document.createElement('div');
    guard.className = 'kl-qty-multiple-checkout-guard';
    guard.setAttribute('role', 'button');
    guard.setAttribute('tabindex', '0');
    guard.setAttribute('aria-label', 'Quantity must be a valid multiple before checkout');
    guard.hidden = true;
    paymentButton.appendChild(guard);
    return guard;
  }

  function syncCheckoutGuard(formRoot) {
    const multiple =
      readMultipleFrom(formRoot) ||
      readMultipleFrom(formRoot.querySelector('[name="quantity"]'));
    if (!multiple) return;

    const paymentButton = formRoot.querySelector('.shopify-payment-button');
    if (!paymentButton) return;

    const guard = ensureCheckoutGuard(paymentButton);
    const valid = isValidQuantity(getFormQuantity(formRoot), multiple);
    guard.hidden = valid;

    if (!guard.dataset.bound) {
      guard.dataset.bound = 'true';
      const blockCheckout = (event) => {
        event.preventDefault();
        event.stopPropagation();
        showInvalidToast(formRoot, multiple);
      };
      guard.addEventListener('click', blockCheckout);
      guard.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          blockCheckout(event);
        }
      });
    }
  }

  function bindCheckoutGuards(formRoot) {
    const multiple =
      readMultipleFrom(formRoot) ||
      readMultipleFrom(formRoot.querySelector('[name="quantity"]'));
    if (!multiple || formRoot.dataset.klQtyMultipleBound === 'true') return;
    formRoot.dataset.klQtyMultipleBound = 'true';

    const sync = () => syncCheckoutGuard(formRoot);

    formRoot.addEventListener('input', (event) => {
      if (event.target && event.target.name === 'quantity') sync();
    });
    formRoot.addEventListener('change', (event) => {
      if (event.target && event.target.name === 'quantity') sync();
    });
    formRoot.addEventListener('click', (event) => {
      if (event.target.closest('.qty-button')) {
        setTimeout(sync, 0);
      }
    });

    // Payment button mounts asynchronously inside a closed shadow DOM.
    const observer = new MutationObserver(sync);
    observer.observe(formRoot, { childList: true, subtree: true });
    sync();
    // Retry a few times in case Shop Pay loads late.
    [300, 1000, 2500].forEach((ms) => setTimeout(sync, ms));
  }

  function initCheckoutGuards() {
    document
      .querySelectorAll('product-form[data-qty-multiple], .product-form[data-qty-multiple]')
      .forEach(bindCheckoutGuards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutGuards);
  } else {
    initCheckoutGuards();
  }

  window.KLQuantityMultiple = {
    parseMultiple,
    readMultipleFrom,
    isValidQuantity,
    showToast,
    showInvalidToast,
    showSuccessToast,
    productLabel,
    bindCheckoutGuards,
    syncCheckoutGuard
  };
})();
